export default __webpack_public_path__ + "static/media/desktop-rules-modal-bonus.8ac22e7f.jpg";